import React, { useEffect, useState } from "react";
import { listCategories } from "../api/catalog";
import { getTopbarOffers } from "../api/topbar";
import NewNavbar from "../components/newNavbar";
import Footer from "../components/Footer";
import BottomNavBar from "../components/BottomNavBar";
import { ChevronLeft, ChevronRight } from "lucide-react";

const API_BASE = process.env.REACT_APP_API_BASE || '/api';

export default function CategoriesPage() {
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);

  const [currentPromoIndex, setCurrentPromoIndex] = useState(0);
  const [topbarOffers, setTopbarOffers] = useState([]);

  useEffect(() => {
    async function fetchCategories() {
      setLoading(true);
      const data = await listCategories();
      setCategories(Array.isArray(data) ? data : []);
      setLoading(false);
    }
    fetchCategories();
  }, []);

  useEffect(() => {
    getTopbarOffers().then((offers) => {
      setTopbarOffers(offers.map((o) => o.offerText));
    });
  }, []);

  useEffect(() => {
    if (!topbarOffers.length) return;
    const promoTimer = setInterval(() => {
      setCurrentPromoIndex((prev) => (prev + 1) % topbarOffers.length);
    }, 4000);
    return () => clearInterval(promoTimer);
  }, [topbarOffers]);

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      {/* Topbar */}
      <div className="bg-pink-500 text-white py-2 relative overflow-hidden">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <div className="flex items-center justify-center gap-4">
            <button
              onClick={() =>
                setCurrentPromoIndex(
                  (prev) =>
                    (prev - 1 + topbarOffers.length) % topbarOffers.length
                )
              }
              className="hover:opacity-70"
            >
              <ChevronLeft size={20} />
            </button>
            <p className="text-sm font-semibold tracking-wide">
              {topbarOffers[currentPromoIndex] || "Welcome to Ferrea Fashion"}
            </p>
            <button
              onClick={() =>
                setCurrentPromoIndex(
                  (prev) => (prev + 1) % topbarOffers.length
                )
              }
              className="hover:opacity-70"
            >
              <ChevronRight size={20} />
            </button>
          </div>
        </div>
      </div>

      <NewNavbar />

      <main className="flex-1">
        <div className="max-w-5xl mx-auto px-4 py-10">
          <h1 className="text-3xl font-bold mb-8 text-center">
            All Categories
          </h1>
          {loading ? (
            <div className="text-center py-10">Loading...</div>
          ) : categories.length === 0 ? (
            <div className="text-center py-10 text-gray-500">
              No categories found.
            </div>
          ) : (
            <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-6 sm:gap-8">
              {categories.map((category, idx) => (
                <div
                  key={category._id || idx}
                  className="flex flex-col items-center"
                >
                  <div className="w-20 h-20 sm:w-24 sm:h-24 rounded-full bg-gray-100 flex items-center justify-center mb-2 shadow-sm">
                    {category.photo ? (
                      <img
                        src={
                          category.photo.startsWith("http")
                            ? category.photo
                            : `${API_BASE}${category.photo}`
                        }
                        alt={category.name}
                        className="w-16 h-16 sm:w-20 sm:h-20 object-contain rounded-full"
                      />
                    ) : (
                      <span className="text-2xl font-bold text-gray-400">
                        {category.name.charAt(0).toUpperCase()}
                      </span>
                    )}
                  </div>
                  <span className="font-bold text-sm sm:text-base text-gray-900 mt-1 text-center">
                    {category.name}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </main>

      <BottomNavBar/>
      <div className="mt-12">
        <Footer />
      </div>
    </div>
  );
}